import React from 'react';
import { Phone } from 'lucide-react';
import { cn } from '../lib/utils';

// Floating "Quick Log Call" button — bottom-right.
// Always visible, prominent on mobile. Hidden via prop while modal is open.
const QuickLogFab = ({ onClick, hidden = false, className }) => {
  if (hidden) return null;
  return (
    <button
      onClick={onClick}
      className={cn(
        'fixed bottom-5 right-5 sm:bottom-6 sm:right-6 z-40',
        'w-14 h-14 sm:w-auto sm:h-auto sm:px-5 sm:py-3 rounded-full',
        'flex items-center justify-center gap-2',
        'bg-gradient-to-br from-emerald-500 to-teal-600 hover:from-emerald-400 hover:to-teal-500',
        'text-white font-display font-bold tracking-tight',
        'shadow-2xl shadow-emerald-500/40',
        'transition-all hover:scale-105 active:scale-95',
        // Pulsing ring (single-layer, GPU-cheap)
        'before:absolute before:inset-0 before:rounded-full before:bg-emerald-400 before:opacity-30 before:animate-ping before:-z-10',
        className,
      )}
      title="Quick log call (press C)"
      aria-label="Quick log call"
      data-testid="quick-log-fab"
    >
      <Phone className="w-5 h-5 sm:w-4 sm:h-4" />
      <span className="hidden sm:inline text-sm">Log call</span>
      <span className="hidden sm:inline opacity-60 text-[10px] font-mono px-1.5 py-0.5 rounded bg-white/15 ml-1">
        C
      </span>
    </button>
  );
};

export default QuickLogFab;
